import { commonApi } from '@common/utils/baseQuery';

import { IUser } from '@features/auth/api/authApi.type';
import config from '../../../config/config';
import { IWithdrawalPasswordCodeAnswer } from './withdrawalPasswordReset';

export type IUserPreview = Pick<IUser, 'lastName' | 'firstName' | 'birthDay' | 'cityId' | 'passportNo' | 'userAddress' | 'email' | 'phone' | 'login'>;

export interface IChangePassword {
  currentPassword: string;
  password: string;
  confirmPassword: string;
}

export interface IResetWithdrawalPassword {
  confirmationCode: string;
  password: string;
  confirmPassword: string;
}

export const profileApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    updateProfile: builder.mutation<Partial<IUserPreview> & { id: number }, IUserPreview>({
      query: (patch) => ({
        url: '/users/profile',
        body: patch,
        method: 'PUT',
      }),
    }),
    changePassword: builder.mutation<void, IChangePassword>({
      query: (patch) => ({
        url: '/users/profile',
        body: patch,
        method: 'PUT',
      }),
    }),
    createWithdrawalPassword: builder.mutation<void, Omit<IChangePassword, 'currentPassword'>>({
      query: (body) => ({
        url: `${config.billingHost}/withdrawals/password`,
        body,
        method: 'POST',
      }),
    }),
    updateWithdrawalPassword: builder.mutation<void, IChangePassword>({
      query: (patch) => ({
        url: `${config.billingHost}/withdrawals/password`,
        body: patch,
        method: 'PUT',
      }),
    }),
    requestWithdrawalPasswordCode: builder.mutation<IWithdrawalPasswordCodeAnswer, void>({
      query: () => ({
        url: `${config.billingHost}/withdrawals/password/code`,
        method: 'POST',
      }),
    }),
    resetWithdrawalPassword: builder.mutation<void, IResetWithdrawalPassword>({
      query: (body) => ({
        url: `${config.billingHost}/withdrawals/password/reset`,
        body,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useUpdateProfileMutation,
  useChangePasswordMutation,
  useUpdateWithdrawalPasswordMutation,
  useCreateWithdrawalPasswordMutation,
  useRequestWithdrawalPasswordCodeMutation,
  useResetWithdrawalPasswordMutation,
} = profileApi;
